import { format } from 'd3-format';
import { formatPhoneNumber } from './formPhoneField';
import { formatDateDef, formatDatetimeDef, formatDatetimeRel } from './formatDate';

export {
  setTimeZone,
  setServerTimeZone,
  setDateFormat,
  getDateFormat,
  getServerTimezoneOffsetMinutes,
  getDate,
  formatDateDef,
  formatDateYMD,
  formatDatetimeDef,
  formatDatetimeYMD,
  formatDatetimeRel,
  getDateCreate,
  getTimeDiff,
  getDateAdd,
  parseDateValue,
  getTime,
  getAgeYrs,
} from './formatDate';


// -- address ---------------------------
export function getWOAddressLine(row) {
  return [
    (row.site_street_number || row.site_street_name) ? (row.site_street_number || '') + ' ' + (row.site_street_name || '') : null,
    row.site_cross_street,
    row.site_city,
    // row.site_state,
    row.site_zip_code,
    row.site_address_2,
  ].filter(Boolean).join(', ');
}
export function getRequestorAddressLine(row) {
  return [
    (row.req_street_number || row.req_street_name) ? (row.req_street_number || '') + ' ' + (row.req_street_name || '') : null,
    row.req_cross_street,
    row.req_city,
    // row.site_state,
    row.req_zip,
    row.req_address_2,
  ].filter(Boolean).join(', ');
}


// -- format value ------------------------
const numberFormatCache = {};
export function formatNumberValue(value, formatStr) {
  if (!value && value != 0) return '';
  if (formatStr) {
    let f = numberFormatCache[formatStr];
    if (f == null) {
      f = format(formatStr);
      numberFormatCache[formatStr] = f;
    }

    const formattedValue = f(value);

    if (formattedValue === 'NaN') {
      return value;
    }

    return formattedValue;
  }
  return value;
}

export function formatCheckValue(value, formatStr) {
  let v = '';
  if (formatStr === 'Y/N') {
    v = [true, 'true', 1, '1', 'Y'].indexOf(value) !== -1 ? 'Y' : 'N';
  } else if (formatStr === '1/0') {
    v = [true, 'true', 1, '1', 'Y'].indexOf(value) !== -1 ? 1 : 0;
  }
  return v || value;
}

const MULTIPLE_SEPARATOR = ',';

export function formatMultipleFromServer(serverValue = '', keyCol) {
  if (!serverValue?.length) {
    return [];
  }

  let value = serverValue.split(MULTIPLE_SEPARATOR);

  value = value.map((r) => {
    return keyCol.reduce((a, k) => {
      a[k] = r?.trim?.();

      return a;
    }, {});
  });

  return value;
}

export function formatMultipleToServer(array = '', keyCol) {
  if (!array?.length) {
    return '';
  }

  const value = array.map((item) => item[keyCol?.[0]]).filter(Boolean);

  return value.join(MULTIPLE_SEPARATOR);
}

export function formatValue(value, type, formatStr) {
  // console.log('format:', value, type);
  if (value === '') return '';
  if (value || value == 0) {
    if (type === 'date') { return formatDateDef(value, formatStr); }
    if (type === 'datetimerel') { return formatDatetimeRel(value); }
    if (type === 'datetime') { return formatDatetimeDef(value); }
    if (type === 'number') { return formatNumberValue(value, formatStr); }
    if (type === 'boolean') { return formatCheckValue(value, formatStr); }
    if (type === 'phone') { return formatPhoneNumber(value); }
    if (formatStr) {
      const f = format(formatStr);
      return f(value);
    }
  }
  return value;
}

// Add-only ("tracked changes") text fields are appended on the server with a
// "< Updated By User: name date>" stamp before each added block (see updateAddonlyText in wohdrupd.php).
export function stripTrackedChanges(text) {
  if (!text) return text;
  return String(text).replace(/<\s*Updated By User:[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
}

// to remove
export function esriDate(d) {
  if (d == null || d == '') return null;
  let dd = new Date(d);
  return dd.toLocaleDateString() + ' ' + dd.toLocaleTimeString();
}
